exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aboutContainer {\n    width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-around;\n    padding-top: 1%;\n}\n\n.aboutContainer .aboutImage {\n    width: 40%;\n}\n\n.aboutContainer .aboutImage img {\n    width: 100%;\n}\n\n.aboutContainer .aboutDesc {\n    width: 50%;\n}\n\n.aboutContainer .aboutDesc .aboutDescNameTitle {\n    text-align: center;\n    border-bottom: 1px black solid;\n    padding-bottom: 2%;\n    font-size: 22px;\n}\n\n.aboutContainer .aboutDesc p {\n    line-height: 175%;\n    font-size: 16px;\n}\n", ""]);

// exports
